<div [ngClass]="'ca-label ' + color()">
    <ng-content></ng-content>
</div>
